import '../init'

import EntryWrapper from '../EntryWrapper.vue'
import Entry from './Entry.vue'
import db from '../db'
import { loadLocaleMessages, t } from '../i18n'

import { subscribeStore, useCommonStore } from '../stores/common-store'
import router from './router'

import 'virtual:uno.css'
import './global.css'
import 'animate.css'
import { createMyApp } from '@/app'

import { fastClick } from '@/directives'
import { afterAppMount, initPlausible } from '@/shared'
import bridge from '@/utils/bridge'
// import mockBridge from '@/utils/bridge/mock'
import { nextTick } from 'vue'

loadLocaleMessages(db.locale).then(init)

async function init() {
  const app = createMyApp(EntryWrapper, { entry: Entry })

  const store = useCommonStore()
  subscribeStore(store)

  // global variables
  window._app = app
  window._store = store
  window._db = db
  window._router = router
  window._bridge = bridge

  app.use(router)
  app.directive('fast-click', fastClick)

  if (_global.isInsideApp) {
    _bridge.webReady()
    await store.getAppInfo()
  }

  // init app
  app.mount('#app')
  nextTick(afterAppMount)

  initPlausible()
}

// 禁止浏览器缩放
document.addEventListener('gesturestart', function (e) {
  e.preventDefault()
})
